<template>
  <v-app :height="height">
    <div id="app" :style="{ height: '100vh' }">
      <div
        v-if="showOverlay && isAuthenticated"
        class="overlay d-flex align-center justify-center"
        ref="loading"
      >
        <!-- <div class="circular-wrapper">
          <div class="circular-background"></div>
          <v-progress-circular
            :value="progressValue"
            :color="loadingColor"
            size="250"
            width="30"
          ></v-progress-circular>
        </div> -->
      </div>
      <v-container fluid class="pa-0" :style="contentStyles">
        <router-view />
      </v-container>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'App',
  data() {
    return {
      showOverlay: false,
      contentStyles: {
        opacity: 0,
        transition: 'opacity 0.5s ease-in-out',
      },
      progressValue: 0,
    };
  },

  computed: {
    ...mapGetters(['GET_EVENT_ID', 'GET_PREFERENCES', 'GET_EVENT_NAME']),
    isAuthenticated() {
      return !!localStorage.getItem('token');
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 220;
        case 'sm':
          return 400;
        case 'md':
          return 500;
        case 'lg':
          return 600;
        case 'xl':
          return 800;
        default:
          return 'auto';
      }
    },
    // loadingColor() {
    //   // Fallback to default color if system_loading_color is not in local storage
    //   return (
    //     // localStorage.getItem('system_loading_color') || '#0000FF' // Default color
    //   );
    // },
  },

  async created() {
    // if (this.isAuthenticated) {
      await this.loadPreferences();
    // }
    // this.applyStoredColors();
  },

  methods: {
    async loadPreferences() {
      const payload = {
        url: 'moduleSettings',
        event_id: this.GET_EVENT_ID,
      };
      try {
        this.showOverlay = true;
        const response = await this.$store.dispatch('urlGet', payload);
        this.$store.commit('PREFERENCES', response);

        if (response.length > 0) {
          localStorage.setItem('preferences', JSON.stringify(response));
          response.forEach((pref) => {
            if (pref.value) {
              document.documentElement.style.setProperty(
                `--${pref.parameter}`,
                pref.value
              );
              if (pref.parameter === 'system_loading_color') {
                localStorage.setItem('system_loading_color', pref.value);
              }
            }
          });
          setTimeout(() => {
            this.showOverlay = false;
            this.contentStyles.opacity = 1;
          }, 10);
        }
      } catch (error) {
        console.error('Error loading preferences:', error);
        this.showOverlay = false;
      }
    },
    // applyStoredColors() {
    //   const storedColor = localStorage.getItem('system_loading_color');
    //   document.documentElement.style.setProperty(
    //     '--system_loading_color',
    //     storedColor ||  '--system_loading_color' 
    //   );
    // },
    startProgress() {
      this.progressValue = 0;
      this.progressInterval = setInterval(() => {
        this.progressValue += 10;
        if (this.progressValue >= 100) {
          clearInterval(this.progressInterval);
        }
      }, 20);
    },
  },

  mounted() {
    if (this.isAuthenticated) {
      this.loadPreferences();
      this.startProgress();
    } else {
      this.showOverlay = false;
    }
  },
  watch:{
    GET_EVENT_NAME:{
      handler(val){
        if(val){
          document.title = `${val ? val.toUpperCase() : ''} ${moment().format('YYYY')}`;
        }
      }
    }
  }
};
</script>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circular-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circular-background {
  position: absolute;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -1;
}
</style>
